import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { VaultPage } from "@/features/vault/components/vault-page";

/**
 * Home = el vault. La compuerta muestra setup (primer arranque) / unlock
 * (bloqueado) / la lista de items (desbloqueado). Local-first: un invitado
 * puede crear su vault e items completamente offline.
 */
function VaultHomePage() {
  return (
    <VaultGate>
      <VaultPage />
    </VaultGate>
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: VaultHomePage,
});
